import PrescriptionRenewal from './PrescriptionRenewal';

export default PrescriptionRenewal;